<template>
  <div class="responsive-menu" :style="cssVars.menu">
    <sidebar-menu :menu="userMenu" :relative="true" :collapsed="isMenuClosed" :showOneChild="true" :disableHover="true"
      :width="menuWidth" @item-click="checkItemClickMenu" class="">
      <div @click="toggleMenu" class="menu-label" slot="header" :style="cssVars.headerMenu">
        <span v-if="!isMenuClosed">Menu</span>
        <font-awesome-icon :icon="isMenuClosed ? 'chevron-right' : 'chevron-left'" />
      </div>
      <span slot="toggle-icon"></span>
      <span slot="dropdown-icon">
        <font-awesome-icon icon="chevron-right" />
      </span>
    </sidebar-menu>
  </div>
</template>

<script>
import menuData from "@/assets/menu.json";
import { store } from "@/store";
import { UtilsTS } from '@/utilsts';

export default {
  name: "MenuComponent",
  mixins: [UtilsTS],
  computed: {
    userMenu() {
      return store.userMenu
    },
    permissoes() {
      return store.permissoes;
    },
    cssVars() {
      return {
        menu: { "--headerHeight": this.headerHeight, "width": this.menuWidth },
        headerMenu: { "width": this.headerMenuWidth }
      }
    }
  },
  data() {
    return {
      isMenuClosed: false,
      menuWidth: '350px',
      headerHeight: 0
    }
  },
  mounted() {
    window.addEventListener('resize', this.onWindowResize)
    this.onWindowResize()
    this.loadUserData()
  },
  methods: {
    onWindowResize() {
      this.checkMenuWidth()
      this.headerHeight = this.getAbsoluteHeight('#headerwrapper') + 'px'
    },
    checkItemClickMenu(event, item) {
      if (store.isLowerResolution) {
        this.isMenuClosed = item.href != ""
      }
    },
    checkMenuWidth() {
      this.isMenuClosed = (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) <= 992
      this.menuWidth = this.isMenuClosed ? '50px' : '350px'
    },
    toggleMenu() {
      this.isMenuClosed = !this.isMenuClosed;
      this.menuWidth = this.isMenuClosed ? '50px' : '350px'
      this.headerMenuWidth = this.isMenuClosed ? 'auto' : '350px'
    },
    async loadUserData() {
      let user = menuData.find((m) => {
        return m.title == "__USER__"
      })
      if (user) user.title = this.capitalize(store.nomeUsuario)
      this.updateUserMenu(store.permissoes)
    },
  },
  watch: {
    permissoes(newVal, oldVal) {
      this.updateUserMenu(newVal)
    }
  }
}
</script>

<style>
@media screen and (max-width: 992px) {
  .responsive-menu {
    float: left;
    position: absolute;
    z-index: 9910;
    top: var(--headerHeight) !important;
  }
}

.responsive-menu {
  transition: 0.25s linear all;
}

.v-sidebar-menu .menu-label span {
  font-size: 18px;
  line-height: 52px;
  font-weight: bold;
  color: rgb(85, 85, 85);
}

.v-sidebar-menu .menu-label {
  cursor: pointer;
  text-align: left;
  padding-left: 15px;
  padding-top: 5px;
  background-color: rgb(238, 234, 234);
}

.v-sidebar-menu .vsm--dropdown>.vsm--list {
  padding-left: 20px !important;
}

.v-sidebar-menu.vsm_relative {
  overflow: hidden;
}

.v-sidebar-menu .vsm--item_open .vsm--link_level-2.vsm--link_active {
  padding-left: 15px;
}

.v-sidebar-menu .vsm--dropdown .vsm--list {
  padding: 0px 5px;
}

.v-sidebar-menu .menu-label svg {
  float: right;
  margin: 12px 14px;
  color: rgb(85, 85, 85);
  font-size: 28px;
}

.v-sidebar-menu .vsm--mobile-item {
  display: none;
}

.v-sidebar-menu {
  background-color: #fcfcfc !important;
  margin-right: 0 !important;
  border-right: #dfdfdf 2px solid;
  border-bottom: #dfdfdf 2px solid;
}

.v-sidebar-menu .vsm--link_hover,
.v-sidebar-menu .vsm--link:hover {
  color: var(--baseColor) !important;
  background-color: #efefef !important;
}

.v-sidebar-menu .vsm--link_level-1 {
  height: 45px;
}

.v-sidebar-menu.vsm_collapsed .vsm--link_level-1.vsm--link_hover .vsm--icon,
.v-sidebar-menu.vsm_collapsed .vsm--link_level-1:hover .vsm--icon {
  color: var(--baseColor) !important;
  background-color: inherit !important;
}

.v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active,
.v-sidebar-menu .vsm--link_level-1.vsm--link_active {
  -webkit-box-shadow: 3px 0px 0px 0px var(--baseColor) inset !important;
  box-shadow: 3px 0px 0px 0px var(--baseColor) inset !important;
}

.v-sidebar-menu .vsm--link {
  color: #555 !important;
  font-size: 15px !important;
}

.v-sidebar-menu .vsm--link_level-1 .vsm--icon {
  color: var(--baseColor) !important;
  background-color: inherit !important;
}

.v-sidebar-menu .vsm--link_exact-active,
.v-sidebar-menu .vsm--link_active {
  background-color: #dfdfdf !important;
  color: #555 !important;
}

.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1,
.v-sidebar-menu .vsm--item_open .vsm--link_level-1.vsm--link_active {
  background-color: var(--baseColor) !important;
  color: #fff !important;
}

.v-sidebar-menu.vsm_expanded .vsm--item_open .vsm--link_level-1 svg,
.v-sidebar-menu .vsm--item_open .vsm--link_level-1.vsm--link_active svg {
  color: #fff !important;
}

.v-sidebar-menu .vsm--item_open .vsm--link_level-2.vsm--link_active {
  background-color: var(--baseColor) !important;
  color: #fff !important;
}

.v-sidebar-menu .vsm--item_open .vsm--link_level-2.vsm--link_active svg {
  color: #fff !important;
}

.vsm--link.vsm--link_level-2.vsm--link_hover.vsm--link_active vsm--link_exact-active {
  background-color: #dfdfdf !important;
  color: #555 !important;
}

.vsm--link.vsm--link_level-3.vsm--link_hover.vsm--link_active vsm--link_exact-active {
  background-color: #dfdfdf !important;
  color: #555 !important;
}

.v-sidebar-menu .vsm--dropdown .vsm--list {
  background-color: #fcfcfc !important;
}

.v-sidebar-menu .vsm--link_level-1.vsm--link_exact-active,
.v-sidebar-menu .vsm--link_level-1.vsm--link_active {
  -webkit-box-shadow: 3px 0px 0px 0px var(--baseColor) inset;
  box-shadow: 3px 0px 0px 0px var(--baseColor) inset;
}

.multiselect__option--selected.multiselect__option--highlight {
  background-color: var(--baseColor) !important;
  color: #fff !important;
}

.v-sidebar-menu .vsm--link_level-1 .vsm--icon {
  height: 20px !important;
  line-height: 25px !important;
  width: 25px !important;
}

.v-sidebar-menu .vsm--header {
  padding: 0 !important;
}

.v-sidebar-menu .vsm--toggle-btn {
  display: none !important;
}

.v-sidebar-menu .vsm--link_level-3 {
  padding-left: 30px !important;
}

.v-sidebar-menu .vsm--title {
  height: 25px !important;
}
</style>